import styled from 'styled-components';

export const ItemWrapper = styled.div`
  height: 100%;
  width: 100%;
  outline: none;
`;
